import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classnames from 'classnames';
import React from 'react';
import { includes, noop } from 'lodash';
import styles from './vertical-card.scss';
import { ItemType } from '@wix/wix-vod-constants/api-types';
import CardDescription from './description/description';
import CardCTA from './cta/cta';
import CardThumbnailPlaceholderIcon, { PLAYABLE_VIDEO_CARD_TYPES } from './thumbnail-placeholder-icon/thumbnail-placeholder-icon';
import { VIDEO_CARD_TYPES } from '@wix/wix-vod-constants/video-cards';
export const VERTICAL_VIDEO_CARD_WIDTH = 210;
export default class VerticalVideoCard extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "handleCardClick", () => {
      const {
        cardData,
        onCardClick
      } = this.props;
      onCardClick(cardData);
    });
  }
  isScheduledVideo() {
    const {
      itemType
    } = this.props.cardData;
    return itemType === ItemType.ItemScheduled;
  }
  hasCTA() {
    const {
      cardData: {
        buttonLabel,
        network
      }
    } = this.props;
    return Boolean(buttonLabel || network) && !this.isScheduledVideo();
  }
  renderThumbnail() {
    const {
      cardData: {
        thumbnailUrl,
        type,
        itemType
      }
    } = this.props;
    const isPlayable = includes(PLAYABLE_VIDEO_CARD_TYPES, type);
    const style = thumbnailUrl ? {
      backgroundImage: "url(" + thumbnailUrl + ")"
    } : null;
    const thumbnailClassNames = classnames(styles.thumbnail, {
      [styles['with-play-icon']]: isPlayable && thumbnailUrl
    });
    return /*#__PURE__*/React.createElement("div", {
      className: thumbnailClassNames,
      style: style
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.icon
    }, /*#__PURE__*/React.createElement(CardThumbnailPlaceholderIcon, {
      type: type,
      itemType: itemType,
      thumbnailUrl: thumbnailUrl
    })));
  }
  render() {
    const {
      cardData,
      className,
      isAccessible,
      labels
    } = this.props;
    const {
      text,
      url,
      type,
      liveLabel
    } = cardData;
    const hasCTA = this.hasCTA();
    const isSocialCard = type === VIDEO_CARD_TYPES.SOCIAL;
    const linkClassNames = classnames(styles.link, {
      [styles['is-social-card']]: isSocialCard
    });
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      tabIndex: "-1",
      "data-hook": "action-card"
    }, /*#__PURE__*/React.createElement("a", {
      className: linkClassNames,
      onClick: this.handleCardClick,
      href: url,
      "aria-hidden": !isAccessible,
      tabIndex: isAccessible ? 0 : -1,
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, this.renderThumbnail(), /*#__PURE__*/React.createElement("div", {
      className: styles['content-wrapper']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.description
    }, text && /*#__PURE__*/React.createElement(CardDescription, {
      text: text,
      liveLabel: liveLabel,
      isShrinkable: isSocialCard,
      withSeparator: isSocialCard ? false : hasCTA
    })), hasCTA && /*#__PURE__*/React.createElement(CardCTA, {
      labels: labels,
      isAccessible: isAccessible,
      cardData: cardData
    }))))));
  }
}
_defineProperty(VerticalVideoCard, "defaultProps", {
  onCardClick: noop
});
//# sourceMappingURL=vertical-card.js.map